import { render } from "./FamilyDiscountOrderInfoCard.vue?vue&type=template&id=6865a750&scoped=true"
import script from "./FamilyDiscountOrderInfoCard.vue?vue&type=script&lang=js"
export * from "./FamilyDiscountOrderInfoCard.vue?vue&type=script&lang=js"

import "./FamilyDiscountOrderInfoCard.vue?vue&type=style&index=0&id=6865a750&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6865a750"]])

export default __exports__